<template>
  <div>
    <section class="boxes">
      <div class="index-content" id="selected_item">
        <b-row class="centered-block">
          <b-col lg="10" xs="12">
            <div class="form-fields">
              <b-row class="justify-content-md-center pt-3">
                <b-col md="10" v-for="(field, index) in inputFields" :key="'input-data-field-' + index.toString()">
                  <InputField :field="field" :default="inputData[field.name]"></InputField>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>
    <b-row class="justify-content-md-center boxes">
      <b-col v-if="session && session.can_undo" md="4" lg="3" cols="6">
        <button type="button" @click="goBack()" class="btn-block btn-base input-choice-btn new-btn-outline-success input-btn">Back</button>
      </b-col>
      <b-col md="4" lg="3" :cols="session && session.can_undo ? 6 : 12">
        <button type="button" class="btn-block btn-base input-choice-btn input-btn" @click="submit()">
          Save
          <font-awesome-icon :icon="['fas', 'caret-right']" class="footer_btn"></font-awesome-icon>
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { InputType } from '../constants'
const InputField = () => import('./InputField')

export default {
  name: 'InputFields',
  components: {InputField},
  props: {
    fields: Object,
    item: Object
  },
  data: function() {
    return {
      inputFields: [],
      inputData: {},
      selectedItem: null
    }
  },
  computed: {
    ...mapState(['session'])
  },
  methods: {
    submit: function() {
      this.$emit('submit', this.inputData) // we're done with this view, move on to the next step
    },
    goBack: function() {
      this.$emit('back') // go back to the previous step
    },
    updateData: function(field, val) {
      this.inputData[field] = val
    }
  },
  created() {
    this.selectedItem = this.item || this.session.selected_item

    // get the input fields
    const fields = Object.entries(this.fields)
    for (const [key, field] of fields) {
      if (field.type !== InputType.Product) {
        this.inputFields.push(Object.assign({name: key}, field))

        if (field.default) {
          // field has a default value, so initialize the field with the default
          this.inputData[key] = field.default
        } else if (this.selectedItem && (key in this.selectedItem)) {
          // initialize field with the value set on the selected item (i.e. current quantity or next bill date)
          this.inputData[key] = this.selectedItem[key]
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
